"use strict";

exports.__esModule = true;
exports.RumEventType = exports.ResourceStatus = exports.AppType = void 0;
var RumEventType = exports.RumEventType = /*#__PURE__*/function (RumEventType) {
  RumEventType["VIEW"] = "view";
  RumEventType["RESOURCE"] = "resource";
  RumEventType["EXCEPTION"] = "exception";
  RumEventType["LONG_TASK"] = "longTask";
  RumEventType["ACTION"] = "action";
  RumEventType["CUSTOM"] = "custom";
  RumEventType["APPLICATION"] = "application";
  return RumEventType;
}({});
/**
 * 枚举值，表示资源是否加载成功
 */
var ResourceStatus = exports.ResourceStatus = /*#__PURE__*/function (ResourceStatus) {
  ResourceStatus[ResourceStatus["Unknown"] = -1] = "Unknown";
  ResourceStatus[ResourceStatus["Failed"] = 0] = "Failed";
  ResourceStatus[ResourceStatus["Success"] = 1] = "Success";
  return ResourceStatus;
}({});
var AppType = exports.AppType = /*#__PURE__*/function (AppType) {
  AppType["browser"] = "browser";
  AppType["miniapp"] = "miniapp";
  AppType["uniapp"] = "uniapp";
  AppType["minigame"] = "minigame";
  return AppType;
}({});